import { Link, useLocation } from 'react-router-dom';

export default function Nav() {
  const { pathname } = useLocation();
  const active = (path) => pathname === path ? 'active' : '';

  return (
    <nav>
      <Link to="/" className="nav-logo">HEYIM<span>PURP</span></Link>
      <div className="nav-links">
        <Link to="/" className={active('/')}>Accueil</Link>
        <Link to="/portfolio" className={active('/portfolio')}>Projets</Link>
        <Link to="/tarification" className={active('/tarification')}>Tarification</Link>
        <Link to="/contact" className="nav-cta">Me contacter</Link>
      </div>
    </nav>
  );
}
